/**
 * 马来语
 */
const lang = {
	lang: { //语言切换
		langlist: [{
			type: "Chinese",
			name: "Chinese",
			langimg: "../assets/zg.png"
		},
		{
			type: "English",
			name: "Inggeris",
			langimg: "../assets/zg.png"
		},
		{
			type: "Traditional",
			name: "China Tradisional",
			langimg: "../assets/zg.png"
		},
		{
			type: "Japanese",
			name: "Jepun",
			langimg: "../assets/zg.png"
		},
		{
			type: "Vietnamese",
			name: "Vietnam",
			langimg: "../assets/zg.png"
		},
		{
			type: "Malay",
			name: "Malay",
			langimg: "../assets/zg.png"
		},
		{
			type: "Hindi",
			name: "Hindi",
			langimg: "../assets/zg.png"
		},
		{
			type: "Thai",
			name: "Thai",
			langimg: "../assets/zg.png"
		},
		{
			type: "Russian",
			name: "RusiaName",
			langimg: "../assets/zg.png"
		},
		{
			type: "Indonesian",
			name: "IndonesiaName",
			langimg: "../assets/zg.png"
		}
		],
		langtype: "Malay",
		langimg: "../assets/zg.png"
	},

	tabbar: { //底部
		index: "halaman rumah",
		activity: "aktiviti",
		to_promote: "Sambungan",
		help: "Bantuan",
		my: "saya"
	},
	// 提示
	prompt: {
		verification: "Ralat kod pengesahan",
		account: "Akaun nombor 8-20 digit, nombor atau huruf murni",
		password: "Katalaluan lebih besar atau sama dengan 6 digit + huruf atau kombinasi aksara",
		two: "Dua kata laluan tidak konsisten",
		successful: "log masuk berjaya",
		loginsuccessful: "Logmasuk berjaya",
		null: "Katalaluan akaun tidak boleh kosong",
		Binding: "Binding succeeded",
		address: "Sila isi alamat",
		Please_choose: "Sila pilih satu item dahulu dan masukkan jumlah taruhan",
		Bet_type: "Sila pilih jenis taruhan dahulu",
		success: "Bertaruhan berjaya",
		complete_password: "Sila masukkan kata laluan lengkap",
		copy_success: "Salin ke papan keratan",
		copy_fail: "salinan gagal",
		Set_success: "Tetapkan berjaya",
		Set_password: "Sila tetapkan kata laluan 6 digit, yang tidak boleh mengandungi 'huruf, padanan dan ruang'",
		update_success: "Berubah berjaya",
		input_number: "Sila masukkan kuantiti",
		addressvalue: "Sila pilih alamat dompet"
	},
	head: { //头部
		luckyhash: "Bertaruhan",
		address: "Bind wallet address",
		history: "Sejarah taruhan",
		help: "Bantuan",
		lotteryRecord: "Rekod loteri",
		notice: "Senarai pengumuman",
		question: "masalah umum",
		performance: "hadiah",
		add_address: "Tambah Dompet",
		asset: "Katalaluan aset",
		balance: "Perincian keseimbangan",
		exchangeRecord: "exchange",
		forrecord: "Tukar rekod",
		language: "Tetapan Bahasa",
		update_assets_password: "Ubah kata laluan aset",
		update_login_password: "Ubah kata laluan log masuk",

		myteam: "Pasukan saya",
		recharge: "Isian semula",
		setting: "tetapkan",
		transactiondetails: "Betting record",
		transfer: "Pemindahan komisi",
		user: "Pusat Peribadi",
		userInfo: "data peribadi",
		withdrawal: "Pengunduran",
		commission: "Pengunduran komisi",
		withdrawalRecord: "Rekod tarik",
		top_up: "Muat semula rekod"
	},
	withdrawalRecord: {
		Select_month: "Pilih bulan",
		afterPrice: "balance",

	},
	withdrawal: {
		withdrawalrecord: "Rekod tarik",
		commission: "Aset boleh tunai",
		number: "Kuantiti untuk dipindahkan",
		withdrawal_number: "Kuantiti tarik",
		money_address: "Alamat dompet",
		addressvalue: "Sila pilih alamat dompet",
		poundage: "Carian Servis",
		immediately: "Pengunduran segera",
		Warm_prompt: "Warm tip: Please fill in the correct wallet address, otherwise you cannot withdraw money. Once the withdrawal wallet address is filled in and bound, it cannot be modified. If you need to modify it, please contact customer service",
		input_password: 'Sila masukkan kata laluan aset',
		betting: "Bet",

	},
	userInfo: {
		Head_portrait: "Personal Avatar",
		account: "nombor akaun",
		Choose_picture: "Pilih Avatar",
		cancel: "batalkan",
		determine: "tentukan"
	},
	user: {
		wallet_account: "Akaun dompet",
		balance: "Perincian keseimbangan",
		top_up: "Muat Semula",
		withdrawal: "Pengunduran",
		my_wallet: "Dompet saya",
		add_wallet: "Tambah Dompet",
		look: "Lihat rekod",
		look_all: "See more",
		Pack_up: "Put away",
		For_record: "Tukar rekod",
		bettingRecord: "Perincian transaksi",
		reward: "Hadiah promosi",
		goCustomerLink: "Perkhidmatan Dalam Talian",
		Commission_account: "Akaun komisi",
		transfer: "transfer",
		number: "Data taruhan",
		transactiondetails: "Papar perincian",
		day: "Bertaruhan hari ini",
		day_winning: "menang hari ini",
		my_team: "Pasukan saya",
		about_we: "Tentang kita",
		center: "Pusat perkhidmatan pelanggan",
		setting: "tetapkan",
	},
	transfer: {
		money: "Imbangan komisi",
		account_balance: "Imbangan akaun",
		number: "Kuantiti untuk dipindahkan",
		select: "Sila pilih",
		Immediately_transfer: "Pemindahan segera",
		password: "Sila masukkan kata laluan aset",
		betting: "Bet",

	},
	transactiondetails: {
		type: "Jenis",
		input_type: "Sila pilih jenis",
		date: "date",
		select_date: "Sila pilih tarikh",
		select: "query",
		bettingmoney: "Jumlah taruhan",
		winning_amount: "Jumlah menang",
		time: "masa",
		not: "tiada data",
		B1: 'Hash bertuah-Saiz bertuah',
		B2: 'Hash bertuah-Kombinasi bertuah',
		B3: 'Hash bertuah-Naga bertuah dan harimau',
		B4: 'Hash bertuah-Perliburan villa bertuah',
		B5: 'Hash bertuah-Nombor bertuah',
		A1: 'Hashi Entertainment City-Kereta bertuah',
		A2: 'Hashi Entertainment City-Kapal bertuah',
		A3: 'Hashi Entertainment City-Kuda perlumbaan bertuah',
		A4: 'Hashi Entertainment City-Saiz bertuah',
		A5: 'Hashi Entertainment City-Kombinasi bertuah',
		A6: 'Hashi Entertainment City-Naga bertuah dan harimau',
		A7: 'Hashi Entertainment City-Perliburan villa bertuah',
		A8: 'Hashi Entertainment City-Nombor bertuah',
		options: [{
			value: "Hash bertuah - dua sisi",
			label: "B1",
		},
		{
			value: "Hash bertuah - kombinasi",
			label: "B2",
		},
		{
			value: "Lucky hash-Kombinasi Naga Harimau",
			label: "B3",
		},
		{
			value: "Lucky hash-Baccarat",
			label: "B4",
		},
		{
			value: "Lucky hash-Gel tunggal",
			label: "B5",
		},
		],
	},
	setting: {
		updatepwd: "Ubah kata laluan log masuk",
		assets_pwd: "Katalaluan aset",
		not: "Not set",
		yes: "Tetapkan",
		language: "Tetapan Bahasa",
		exit: "tandatangan keluar",

	},
	recharge: {
		recharge_code: "Muat semula rekod",
		Chain_type: "Jenis rantai",
		address: "Muat semula alamat",
		copy_address: "Salin alamat",
		remind: "Peringatan operasi",
		content: "Kandungan kandungan kandungan kandungan kandungan"
	},
	myteam: {
		select: "query",
		time: "date",
		money: "Komisi Hari",
		people: "Bilangan subordinat langsung",
		team: "Pasukan",
		jryj: 'Keputusan hari ini',
		jrsy: 'Pendapatan hari ini',
		ljsy: 'pendapatan terkumpul',
		friendsCategoryList: ['kawan kelas pertama', 'kawan menengah', 'rakan peringkat ketiga', 'kawan darjah 4', 'kawan tingkatan 5'],
	},
	login: {
		order_password: "Katalaluan lama",
		input_ordpwd: "Sila masukkan kata laluan lama anda",
		new_pwd: "Katalaluan baru",
		number: "Sila tetapkan 6-16 huruf atas dan huruf kecil + nombor",
		six_pwd: "Sila masukkan kata laluan 6 digit",
		confirmPassword: "Sahkan kata laluan",
		confirm: "sahkan",
	},
	forrecord: {
		spending: "Biaya pertukaran",
	},
	exchangeRecord: {
		exchangeRecord: "exchange",
		record: "rekod",
		For_spending: "Biaya pertukaran",
		money: "Jumlah pertukaran",
		exchange_number: "Exchange quantity",
		number: "kuantiti",
		market_price: "Harga pasar",
		Miners_fee: "Gaji tambang",
		input_money: "Sila masukkan jumlah pertukaran",
		Get_the_amount: "Jumlah yang diperoleh",
		Can_be: "Jumlah yang tersedia",
		address: "Alamat dompet",
		Immediatelychange: "Buang semula sekarang",
		Warm_prompt: "peringatan",
		details: "Perincian"
	},
	balance: {
		balance_of: "balance",
		data: "date",
		dataPickerRange: "Sila pilih",
		select: "query",
		to: 'to'
	},
	asset: {
		password: "Sila tetapkan kata laluan 6 digit, yang tidak boleh mengandungi 'huruf, padanan dan ruang'",
		confirm: "sahkan",
	},
	add_address: {
		money_address: "Sila masukkan alamat dompet (trc20)",
		save: "penyimpanan"
	},
	spread: {
		cumulative: "Undangan cumulatif anda",
		people: "people",
		make: "Diperoleh",
		Continue_to: "Teruskan berjuang untuk hadiah besar",
		url: "Kongsi pautan",
		Friends_registered: "Pendaftaran rakan",
		money: "Dompet Pautan",
		Friends_deal: "Transaksi kawan",
		copy_url: "Salin undangan pautan",
		my_group: "Pasukan saya",
		look: "Lihat perincian prestasi",
		directCount: "Bilangan subordinat langsung",
		group: "Bilangan pasukan",
		Commission_withdrawal: "Pengunduran komisi",
		historyAward: "Komisi Sejarah diterima",
		yesterdayAward: "Commission yesterday",
		currentAward: "Penerimaan komisi semasa",
		todayAward: "Pertunjukan hari ini",
		my_invite: "Kod undangan saya",
		copy_invite: "Salin kod undangan",
		top_title: "Atasan saya",
		update: "Ia tidak boleh diubahsuai selepas ibubapa terikat",
		nikname: "Sila masukkan gelaran induk untuk ikat",
		binding: "ikatan",
		Commission_ratio: "kadar komisi",
		level: "level",
		ratio: "Nisbah semula (jumlah taruhan)",
		Directly_under: "Subordinat langsung",
		first: "Pertama",
		levelone: "level",

	},
	performance: {
		datatime: "date",
		pick: "Sila pilih",
		select: "query",
		total: "Jumlah prestasi hari ini",
		performance: "Perincian prestasi",
		directCount: "Bilangan pemain langsung",
		todayTotalPerformByDirect: "Pelayan langsung hari ini",
		other: "Number of other players",
		todayTotalPerformByOther: "Performance of other players",
		Commission_withdrawal: "Pengunduran komisi",
		historyAward: "Komisi Sejarah diterima",
		yesterdayAward: "Commission yesterday",
		currentAward: "Penerimaan komisi semasa",
		todayAward: "Pertunjukan hari ini",
		Commission_ratio: "kadar komisi",
		level: "level",
		ratio: "Nisbah semula (jumlah taruhan)",
		Directly_under: "Subordinat langsung",
		first: "Pertama",
		levelone: "level",
	},
	lotteryRecord: { //开奖记录
		block: "blok",
		highly: "tinggi blok",
		results_of: "hasil",

	},
	help: {
		DAPP: "Langkah permainan DAPP",
		a: "Salin alamat permainan DAPP untuk pemindahan usdt-trc20",
		b: "Buka laman web ini dalam pelayar rantai blok dompet (rangkaian TRX), anda boleh bertaruh pada DAPP segera tanpa menyalin",
		Focus_on: "Sila sentiasa perhatikan untuk menyegarkan halaman rumah kita untuk mendapatkan alamat transaksi terbaru.",
		login: "Log masuk ke laman web rasmi medan gelombang untuk tanya nilai hash blok",
		hash: "Anda boleh tanya nilai hash blok anda pada laman web rasmi medan gelombang",
		you: "Anda boleh melawat laman web rasmi medan gelombang",
		login_website: "Log masuk ke laman web rasmi medan gelombang",
		query: "Tanya nilai hash blok anda pada",
		look: "Klik untuk melihat tutorial",
		congratulations: "Tahniah.",
		winning: "Jika anda menang hadiah, sistem akan mengembalikan hadiah kepada anda dalam 1 minit",
		address: "Jika anda menang hadiah, sistem akan mengembalikan hadiah ke alamat pemindahan anda dalam 1 minit",
		number: "Beli usdt dan TRX dalam pertukaran wang digital",
		skip: "Jika dompet anda sudah mempunyai usdt dan TRX, anda boleh melangkah langkah ini",
		Digital_currency: "Beli usdt dan TRX dalam pertukaran wang digital, kemudian pindahkan usdt dan TRX ke [dompet yang ditentralkan] anda. Anda boleh guna dompet yang terdaftar di laman web dompet yang ditentralkan berikut:",
		platform: "platform",
		url: "laman web",
		tutorial: "course",
		vpn: "Tip ramah: jika anda tidak boleh buka telegraf, anda boleh guna VPN Tuhan",
		vpnurl: "Lampu ajaib laman web VPN",
		whirlwind: "Laman web pemecut siklon",
		can_login: "Anda boleh log masuk",
		why: "Mengapa pilih XXXX",
		most_fair: "Yang paling adil",
		play: "Tiada tendangan, tiada jatuh, tiada gangguan",
		Publicly_available: "Nilai hash blok dijana secara rawak, keputusan disatukan, tidak dapat diubah, dan boleh diperiksa secara awam",
		security: "Lebih selamat",
		no_money: "Kebanyakan kerja boleh dilihat.",
		Cannot: "Rekod pemindahan pemilik boleh dilihat dan tidak boleh diterbitkan secara palsu",
		Visi_convenient: "Most convenient",
		Without_registration: "Tidak perlu mendaftar, tidak perlu mengisi semula, tidak perlu meminta penarikan",
		questions: "masalah umum",
		one: "Apa [nilai hash blok]（Block Hash）",
		dna: "Nilai hash blok adalah DNA bagi sebahagian data. Setiap nilai hash blok adalah unik, rawak dan tidak boleh patah。",
		lookintroduce: "Klik untuk melihat perkenalan nilai hash enciklopedia Baidu。",
		what: "Rangkaian blok apa",
		Block_chain: "Pada dasarnya, blockchain adalah pangkalan data terkongsi yang mana data atau maklumat disimpan. Ia mempunyai ciri-ciri bukan palsu, meninggalkan jejak dalam keseluruhan proses, pengesan, terbuka dan keseluruhan, pemeliharaan kolektif dan sebagainya.",
		wallet: "Dompet pusat? Dompet yang ditentralkan? Mengapa dompet pusat tidak dapat meminta pemindahan？",
		example: "Contohnya, jika alamat dompet and a adalah a dan anda memindahkan alamat e ke 10usdt, tetapi anda menggunakan nilai hash transaksi untuk tanya, anda hanya boleh tanya pemindahan antara alamat buku akaun rawak penyedia perkhidmatan B (atau C atau D, dll.) dan E. Sama seperti, e tidak tahu sama ada 10 usdts ini dipindahkan oleh anda, kerana e hanya boleh melihat bahawa ia adalah alamat buku akaun B yang dipindahkan dalam 10 usdts kepadanya. This is why the centralized wallet cannot query the real transfer information on the block shoes.",
		why_winning: "Mengapa saya menang atau tidak menang berturut-turut",
		First: "Pertama-tama, ia adalah peristiwa kebarangkalian kecil yang tidak memenangkan hadiah untuk banyak kali berturut-turut",
		small: "Definisi peristiwa kebarangkalian kecil",
		second: "Kedua, menang dan tidak menang adalah peristiwa rawak, dan frekuensi peristiwa rawak akan cenderung kepada nilai yang stabil. Dalam kes tidak berulang, kemungkinan perkara yang muncul adalah sama untuk semua orang. Pada masa yang sama, peristiwa rawak akan mematuhi undang-undang nombor besar (dalam syarat ujian tetap tidak berubah, ulangi ujian banyak kali, dan frekuensi peristiwa rawak sama dengan definisi undang-undang nombor besar). Apabila frekuensi pemindahan terus meningkat, kemungkinan menang atau tidak menang akan cenderung kepada nilai yang stabil. Jika frekuensi pemindahan meningkat, keseluruhan kemungkinan untuk menang hadiah akan meningkat.",
		whydelay: "Mengapa ia tertunda",
		Click_to_view: "Klik untuk melihat persekitaran kelajuan blockchain： 《Percaya adalah apa yang dihitung, perlahan adalah apa yang dihitung》",
		six: "Mengapa ada kunci bila memindahkan wang? Lalu apa pilihan jenis usdt? Yang mana yang harus saya pilih？",
		global: " Terdapat banyak rantai awam yang terkenal di seluruh dunia",
		click_look: "Klik untuk melihat perkenalan rantai awam Zhige global",
		how: "Apabila memindahkan wang, apa yang patut saya lakukan jika saya memindahkan alamat atau pilih jenis wang yang salah? Boleh saya kembali？",
		For_instance: " Contohnya, apabila anda memindahkan wang kepada kami, anda patut pilih trc20 di bawah USD, tetapi jika anda memilih Omni atau usderc20 di bawah jenis lain USD, anda akan kehilangan wang, yang tidak boleh dikembalikan.",
		How_to_force: "Klik untuk melihat apa yang perlu dilakukan jika anda memindahkan wang yang salah？",
		Other_problems: "Masalah lain",
		callwe: "Jika anda mempunyai sebarang soalan, sila hubungi kami",
		immediately: "Bertaruhan sekarang",
		company: "Maklumat syarikat",
		link: "Pautan",
		register: "Dompet yang ditetapkan",
		Already_have: "Jika anda sudah mempunyai dompet, anda boleh melangkah langkah ini",
		download: "Muat turun dan daftar duit digital yang ditentralkan",
		com_title: "Tutorial laman web berkaitan dengan dompet wang digital adalah seperti berikut"
	},
	register: { //登录注册
		login_tips: "Sila tetapkan semula kata laluan log masuk anda",
		address: "Sila masukkan alamat dompet",
		confirm: "Sahkan kata laluan",
		confirmupdate: "Confirm modification",
		toRegister: "Pergi daftar",
		agreement: "Sign in and agree",
		user: "Perjanjian pengguna",
		policy: "Polisi Privasi",
		welcome: "Selamat datang ke",
		login: "Log masuk ke akaun anda",
		forget: "Lupakan kata laluan",
		nowLogin: "Daftar masuk",
		nologin: "Jangan log masuk sementara",
		new: "Cipta akaun baru",
		login: "Sebagai akaun daftar masuk anda",
		account: "Akaun nombor 8-20 digit, nombor atau huruf murni",
		password: "Katalaluan lebih besar atau sama dengan 6 digit + huruf atau kombinasi aksara",
		confirm_password: "Sahkan kata laluan",
		inviteCode: "Please enter the invitation code (optional)",
		verificationCode: "Sila masukkan kod pengesahan",
		toRegister: "daftar",
		noaccount: "Tiada akaun",
		toLogin: "Pergi log masuk"
	},
	address: {
		warmprompt: "Warm tip: Please fill in the correct wallet address, otherwise you cannot withdraw money. Once the withdrawal wallet address is filled in and bound, it cannot be modified. If you need to modify it, please contact customer service",
		tips: "Sila ikat sekurang-kurangnya satu alamat dompet. Anda tidak boleh dapatkannya bila anda lupa kata laluan anda",
		TRC20: "Untuk mengelakkan ralat input, sila salin dan tekan panjang di sini untuk lekap (trc20)",
		toBind: "Ikat sekarang",
		noBind: "Jangan ikat sementara",
	},
	luckyhash: { //幸运哈希
		walletName: 'Dompet Pautan',
		exchange: "exchange",
		reward: "hadiah",
		Customerservice: "perkhidmatan pelanggan",
		instructions: "jelaskan",
		luckyhash: "Lucky hash",
		entertainment: "Bandar hiburan Hashi",
		Doublesided: "dua-sisi",
		odds: "Odds",
		immediately: "Bertaruhan sekarang",
		combination: "kombinasi",
		LongHuge: "Kombinasi Naga Harimau",
		baccarat: "Baccarat",
		gallbladder: "Gel tunggal",
		Hashracingcar: "Perlombaan Hash",
		Hashspeedboat: "Kapal kelajuan Hashi",
		Hashracing: "Perlombaan kuda",
		bothsides: "dua sisi",
		problem: "masalah umum",
		all: "See more",
		friend: "rakan kerjasama"
	},
	history: {
		block: "blok",
		type: "Jenis",
		big: "besar",
		highly: "tinggi blok",
		results_of: "hasil"
	},
	entertainment: {
		lastBlock: "Blok sebelumnya",
		resultValue: "Hasil loteri",
		currentblock: "Blok Semasa",
		nextBlock: "The lottery block",
		toLotteryRecord: "Rekod loteri",
		block: "blok",
		money1: "jumlah wang",
		type: "Jenis",
		all: "See more",
		both_sides: "dua sisi",
		big: "besar",
		small: "Kecil",
		single: "single",
		double: "ganda",
		champion: "juara",
		yajun: 'runner-up',
		champion_one_size: "Champion single size",
		crown: "Guanyahe",
		andbig: "Heda",
		andsmall: "Dan kecil",
		andsingle: "Hedan",
		anddouble: "Dan ganda",
		championtwo: "Dua sisi juara",
		combination: "kombinasi",
		forlarge: "Arahan besar",
		smallsingle: "Small order",
		large_double: "Dashuang",
		small_double: "Xiao Shuang",
		Long_Huge: "Kombinasi Naga Harimau",
		dragon: "Loong",
		tiger: "harimau",
		us: "tutup",
		baccarat: "Baccarat",
		zhuang: "Zhuang",
		idle: "Leisure",
		gallbladder: "Gel tunggal",
		Atotalof: "umum",
		note: "nota",
		Check_the_details: "Papar perincian",
		money: "Imbangan dompet",
		pause: "Pemilihan Mesin",
		reset: "Tetap Semula",
		inputmoney: "Sila masukkan jumlah",
		submit: "Hantar",
		password: "Please enter the transaction password",
		betting: "Bet",
		determine: "tentukan",
	},
	details: {
		block: "blok",
		money: "jumlah wang",
		type: "Jenis",
		resultValue: "Hasil loteri",
		all: "See more",
		address: "Alamat taruhan",
		toLotteryRecord: "Rekod loteri",
		money: "Taruhan dompet",
		copy: "Salin alamat taruhan",
		ts: "Sila jangan guna alamat pertukaran, jika tidak anda tidak akan menerima hadiah",
		USDT: "Please transfer the wave field usdt / TRX (trc20)",
		Betting_amount: "Jumlah taruhan",
		inputmoney: "Sila masukkan jumlah taruhan",
		confirm: "sahkan",
		cancel: "batalkan",
	},
	data: {
		noData: 'Tiada data',
		deleteSuc: 'Dihapuskan dengan berjaya',
		iscon: 'Tiada taruhan dibenarkan semasa masa tutup',
		fenpan: 'Tiada taruhan dibenarkan semasa masa tutup',
		erweima: 'Save QR code'
	},
	announcement: {
		title: 'Pengumuman Terkini',
		close: 'penutupan',
	},
	phone: {
		title: 'Ikat nombor bimbit',
		phone: 'cell-phone number',
		input: 'Sila masukkan nombor telefon bimbit terikat',
		code: 'Verification Code',
		inputcode: "Sila masukkan kod pengesahan",
		getCode: 'Dapatkan kod pengesahan',
		details: 'Sila isi kod kawasan dan nombor bimbit dahulu',
		success: 'Kod pengesahihan dihantar dengan berjaya',
		bsuccess: 'Pengikatan berjaya',
		jiaoyi: 'Sila tetapkan kata laluan transaksi dahulu',
		caozuo: "Operasi berjaya",
		touxiang: "Sila pilih gambar",
		buzu: 'Maaf, kredit awak dah runtuh.',
		tuiguan: 'Pusat Promosion',
		qubie: 'Klik untuk melihat perbezaan antara dompet rangkaian blok',

		yhm: 'Sila masukkan nama pengguna anda',
		mm: 'Sila masukkan kata laluan anda',
		xqgg: 'Pergi tengok dulu.',
		llwm: 'hubungi kami',
		lj: 'Sila sambung dompet anda dahulu',
		dk: 'Sila buka dalam aplikasi dompet',
		qd: 'Kami menantikan penyertaan anda',
		yjmx: 'Perincian'
	},
	vip: {
		jl: "reward",
		xrjl: 'Hadiah baru',
		ckgz: 'Papar peraturan',
		zcsj: 'Deposit pendaftaran',
		qbsj: 'Ikat telefon bimbit dan alamat dompet',
		dlq: 'tidak diklaim',
		qwc: 'Untuk selesai',
		ylq: 'Diterima',
		tgrw: 'Tugas promosi',
		rwjl: 'Hadiah Tugas',
		yq: 'undangan',
		ghy: 'Kawan kualiti',
		lqcg: 'Received successfully',
		bz: "Please enter the recharge currency",
		je: 'Please enter the recharge amount',
		xyb: 'next step',
		czpz: 'Please upload the recharge voucher',
		zzhx: 'Please enter transfer hash',
		ljtj: 'Submit now'

	}

}
export default lang



// WEBPACK FOOTER //
// ./src/i18n/language/Malay.js